import http from './http';
import api from './api-config';

//--- 获取验证码
export function serviceHelper(data) {
  return http.post(api.helper, data);
}

//--- 微信端优化
export function serviceWechatJSAPI(data) {
  return http.post(api.wechat, data);
}